var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rules-display",class:{
    'rules-display--large': _vm.large,
    'rules-display--collapsible': _vm.collapsible
  }},[_c('div',{staticClass:"rules-display__body",class:{
      'rules-display__body--collapsed': !_vm.show
    }},[_c('span',{staticClass:"rules-display__copy",domProps:{"innerHTML":_vm._s(_vm.copyBody)}}),_c('router-link',{staticClass:"rules-display__cta",attrs:{"to":{
        name: _vm.termsRoute
      }}},[_vm._v(_vm._s(_vm.copyCta))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }